module.exports = __webpack_public_path__ + "static/media/HomePic2.9e602fde.jpg";